import { PlayArrow } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

import { ListItemButton } from 'components/List'
import { useStartAbTest } from './hooks/useStartAbTest'
import { StartTestItemProps } from './types'

export const StartTestItem = ({ id }: StartTestItemProps): JSX.Element => {
  const { t } = useTranslation('features/abTests')
  const { startAbTest } = useStartAbTest()

  return (
    <ListItemButton
      data-cy='actions-start-test'
      icon={<PlayArrow data-cy='play-arrow-icon' />}
      onClick={(): void => startAbTest(id)}
      text={t('list.actions.startTest.label')}
    />
  )
}
